<template>
  <ul class="navbar-wrapper" :class="classObj">
    <li v-if="loggedIn">
      <button
        class="icon-button menu"
        @click.stop="showSidebar"
        aria-label="Menu button">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      </button>
    </li>
    <li v-if="loggedIn">
      <Balances displayMerchantSelect showLabels :isDropdown="isFiatMerchant" />
    </li>
    <li class="dropdown" v-if="loggedIn">
      <button
        class="icon-button dropdown-trigger"
        @click="toggleDropdownContent()"
        v-click-outside="hideDropdownContent">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill="#505050"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z" />
        </svg>
        {{ dashboardEmail }}
      </button>
      <ul
        class="dropdown-content"
        :class="{ hide: !shouldDisplayDropdownContent }">
        <li>
          <router-link to="/profile-and-bank-accounts" exact>Manage Profile</router-link>
        </li>
        <li>
          <router-link to="/payment-options" exact>Payment options</router-link>
        </li>
        <li><router-link to="/customize" exact>Customize</router-link></li>
        <li v-if="isAdminGetter">
          <router-link to="/manage-users" exact>Manage Users</router-link>
        </li>
        <li v-if="hasFiatPayoutsRights">
          <router-link to="/manage-fiat-accounts" exact>Manage Fiat Accounts</router-link>
        </li>
        <li v-if="isAdminGetter">
          <router-link to="/authentication-page" exact>Security Settings</router-link>
        </li>
        <li>
          <router-link to="/changeprofile" exact>Change Password</router-link>
        </li>
        <li><router-link to="/logout" exact>Logout</router-link></li>
      </ul>
    </li>
    <li v-if="!isLoggedIn()">
      <router-link :to="'/login'" :target="'_self'" exact>Login to access Dashboard</router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import Balances from '../../components/balances/Balance.vue';
import FiatBalances from '../../components/balances/FiatBalances.vue';

export default {
  name: 'the-navbar',
  components: {
    FiatBalances,
    Balances
  },
  props: {
    navbarColor: {
      type: String,
      default: 'transparent',
    },
  },
  mounted() {
    this.checkFiatRights();
  },
  data() {
    return {
      shouldDisplayDropdownContent: false,
      hasFiatPayoutsRights: false,
      shouldShowFiatBalance: false,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
    activeMerchantGetter() {
      this.checkFiatRights();
    },
    storedActiveMerchantGetter() {
      this.checkFiatRights();
    },

  },
  computed: {
    ...mapGetters(['isAdminGetter', 'currentActiveEntityAdminGetter', 'activeMerchantGetter', 'storedActiveMerchantGetter']),

    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == 'default') {
        return '';
      } else if (this.sidebarWidth == 'reduced') {
        return 'navbar-reduced';
      } else if (this.sidebarWidth) return 'navbar-full';
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },

    // PROFILE
    dashboardEmail() {
      return (
        (this.currentActiveEntityAdminGetter &&
          this.currentActiveEntityAdminGetter.email) ||
        (this.$store.state.activeUser && this.$store.state.activeUser.email)
      );
    },
    // activeUserImg() {
    //     return localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).photoURL : this.$store.state.AppActiveUser ? this.$store.state.AppActiveUser.img : null;
    // }

    loggedIn() {
      //return this.$store.state.activeUser !== null;
      return !!this.$store.state.activeUser;
    },

    fiatBalancesGetter() {
      return this.$store.getters.fiatPayoutBalanceListGetter;
    },
    isFiatMerchant() {
      return this.$store.getters.storedActiveMerchantGetter && this.$store.getters.activeMerchantGetter.is_fiat_payout;
    },
  },
  methods: {
    toggleDropdownContent() {
      this.shouldDisplayDropdownContent = !this.shouldDisplayDropdownContent;
    },
    displayDropdownContent() {
      this.shouldDisplayDropdownContent = true;
    },
    hideDropdownContent() {
      if (this.shouldDisplayDropdownContent) {
        this.shouldDisplayDropdownContent = false;
      }
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
    checkFiatRights() {
      this.hasFiatPayoutsRights = this.$store.getters.activeMerchantGetter.is_fiat_payout;
    },
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-wrapper {
  max-height: 100px;
  position: fixed;
  z-index: 999;
  display: flex;
  flex-flow: row;
  align-items: center;
  background: linear-gradient(180deg,
      hsla(0, 0%, 97.3%, 0.99) 44%,
      hsla(0, 0%, 97.3%, 0.95) 73%,
      hsla(0, 0%, 100%, 0));
  top: 0;
  padding: 6px 6px 0 0;

  button.icon-button {
    border: none;
    background: none;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    font-size: 1em;

    &:hover {
      cursor: pointer;
      background-color: #eee;
      text-decoration: underline;
    }

    &.menu {
      height: 48px;
      width: 48px;
      border-radius: 50%;
    }

    &.dropdown-trigger {
      display: flex;
      word-break: break-all;
      align-items: center;
      width: 100%;
      color: #505050;

      svg {
        margin-right: 6px;
        overflow: visible;
      }

      &:hover {
        background: none;
      }
    }
  }

  .dropdown {
    position: relative;
    margin-left: auto;
    margin-right: 6px;
    display: flex;
    flex-wrap: nowrap;
    min-width: 150px;
    flex-grow: 0;

    ul.dropdown-content {
      position: absolute;
      top: 32px; // navbar width + some margin
      left: 0;
      background-color: white;
      width: 100%;
      box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 6px;

      li {
        padding: 6px;

        a {
          color: #505050;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &.hide {
        display: none;
      }
    }
  }

  .balances-wrapper {
    flex-grow: 2;
  }
}

@media screen and (min-width: 1200px) {
  .navbar-wrapper {
    width: calc(100% - 260px);

    button.menu {
      display: none;
    }
  }
}
</style>
